import DOMPurify from "dompurify";

/**
 * Odkażanie treści maila PRZED pokazaniem jej w aplikacji.
 *
 * Po drugiej stronie jest operator, a nie napastnik — ale mail to najłatwiejszy
 * kanał podstawienia cudzej treści (przekierowana wiadomość, spoofowany nadawca),
 * więc traktujemy go tak samo jak odpowiedzi firm w module leadów.
 *
 * Lista dozwolonych znaczników jest szeroka, bo korespondencja z ENERGA to tabele,
 * numerowane listy i podpisy i mają wyglądać jak w Outlooku. Nie ma na niej
 * niczego wykonywalnego: żadnych skryptów, zdarzeń, iframe'ów ani atrybutu style.
 */
export function sanitizeMailHtml(html: string): string {
  // Obrazy `cid:` (logo stopki) żyją jako załączniki inline w Exchange — mail
  // u adresata pokaże je poprawnie, ale przeglądarka nie umie rozwiązać cid:
  // i rysuje zepsutą ramkę. W NASZYM podglądzie je chowamy.
  const withoutCid = (html || "").replace(/<img[^>]*src=["']cid:[^"']*["'][^>]*>/gi, "");
  return DOMPurify.sanitize(withoutCid, {
    ALLOWED_TAGS: [
      "p", "br", "div", "span", "strong", "b", "em", "i", "u", "s",
      "ul", "ol", "li", "h1", "h2", "h3", "h4", "blockquote", "pre", "code",
      "table", "thead", "tbody", "tr", "td", "th", "hr", "a", "img",
    ],
    ALLOWED_ATTR: ["href", "title", "alt", "src", "colspan", "rowspan", "start"],
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|data:image\/(?:png|jpe?g|gif|webp))/i,
  });
}

/** Komunikat błędu z koperty { data, errors, meta }. */
export function extractError(err: unknown): string {
  const response = (err as { response?: { data?: { errors?: unknown } } })
    ?.response;
  const errors = response?.data?.errors;
  if (!errors) return "Wystąpił błąd. Spróbuj ponownie.";
  if (typeof errors === "string") return errors;
  if (typeof errors === "object") {
    return Object.values(errors as Record<string, unknown>)
      .flat()
      .join(" ");
  }
  return "Wystąpił błąd. Spróbuj ponownie.";
}
